module.exports = __webpack_public_path__ + "static/media/list_sort_arrow.15dba15e.svg";